import { Component, Inject } from '@angular/core';
import { MmDialogData, MmDialogRefService } from '@metromarkets/components';
import { CartNavigatorService } from '~shared/modules/cart-navigator/cart-navigator.service';
import { CartOfferLine } from '~shared/modules/shopping-cart-store';

@Component({
  selector: 'app-invalid-offer-overlay',
  templateUrl: './invalid-offer-overlay.component.html',
  styleUrls: ['./invalid-offer-overlay.component.scss']
})
export class InvalidOfferOverlayComponent {
  invalidOffers: CartOfferLine[];

  constructor(
    private dialogRefService: MmDialogRefService<InvalidOfferOverlayComponent>,
    private cartNavigatorService: CartNavigatorService,
    @Inject(MmDialogData) public data: { invalidOffers: CartOfferLine[] },
  ) {
    this.invalidOffers = data.invalidOffers;
  }

  onGoToCart() {
    this.dialogRefService.close();
    this.cartNavigatorService.navigateToCart().subscribe();
  }
}
